module.exports = __webpack_public_path__ + "static/media/auth.eb97a11d.png";